import CarotekColors from "@carotek/utils/Colors";
import { cookiePrivacyPolicyPopupStyles } from "@insite/content-library/Components/CookiePrivacyPolicyPopup";
import getColor from "@insite/mobius/utilities/getColor";

import { css } from "styled-components";

Object.assign(cookiePrivacyPolicyPopupStyles, {
    ...cookiePrivacyPolicyPopupStyles,
    drawer: {
        position: "bottom",
        size: 80,
        cssOverrides: {
            drawerTitle: css`
                display: none;
                bottom: -2px;
            `,
            drawerContent: css`
                padding: 15px;
                margin: 0 auto;
                width: 100%;
                background-color: ${CarotekColors.grey16};
                color: ${CarotekColors.white};
                height: 100%;
            `,
        },
        closeButtonProps: {
            css: css`
                display: none;
            `,
        },
        enableClickThrough: true,
    },
    messageGridItem: {
        width: [12, 12, 7, 10, 10],
        css: css`
            text-align: center;
        `,
    },
    acceptGridItem: {
        width: [8, 9, 3, 1, 1],
        css: css`
            width: auto !important;
            flex-basis: auto !important;
            max-width: auto !important;
            padding-right: 0;
        `,
    },
    acceptButton: {
        css: css`
            width: 100%;
            padding: 0.7em 1.2em;
            background-color: ${CarotekColors.grey2} !important;
            border-color: ${CarotekColors.grey2} !important;
            :hover {
                opacity: 0.9;
            }
        `,
        typographyProps: {
            transform: "capitalize",
            color: `${CarotekColors.white}`,
            fontFamily: "OpenSansBold",
        },
    },
    closeGridItem: {
        width: [4, 3, 2, 1, 1],
        css: css`
            width: auto !important;
            flex-basis: auto !important;
            max-width: auto !important;
            padding-left: 0;
        `,
    },
    closeButton: {
        css: css`
            width: 100%;
            padding: 0 15px;
            color: ${getColor("text.main")};
            border-color: transparent;
            background-color: transparent;

            :hover {
                background-color: ${CarotekColors.grey2} !important;
                border-color: ${CarotekColors.grey2} !important;
                [class^="IconWrapper"] {
                    color: white !important;
                }
            }

            [class^="IconWrapper"] {
                color: ${getColor("text.main")};

                svg {
                    width: 20px;
                    height: 20px;
                }
            }
        `,
        variant: "secondary",
    },
});
